import EditEntry from "./EditEntry";

export default EditEntry;
